import * as z from "zod";

/**
 * Seeds, activates, and enables the canonical default Gale LMN questionnaire
 * flow for the team. Beta: 404s for non-employees; 400s when a real flow exists.
 */
export const applyDefaultHsaQuestionnaireFlow = {
  name: "applyDefaultHsaQuestionnaireFlow" as const,
  input: z.null(),
  output: z.object({
    /** The now-active default flow. */
    flowId: z.string(),
  }),
};
